export default __webpack_public_path__ + "static/our-mission-d58aad00afa35bd12c102e1e03c867ee.png";